// Real-time single-device watcher (roadmap #41). Mounted behind RequireStaffAuth,
// it subscribes to this device's presence node and signs the staff out the instant
// another device claims the account (subscribeDeviceSession → forceStaffLogout).
// Renders nothing. Mirrors the old frontend loggedindevice.component.tsx.
import { useEffect } from 'react'
import { globals } from '../core/globals'
import { getDeviceId, forceStaffLogout } from './staffAuth'
import { subscribeDeviceSession } from './deviceSession'

const StaffSessionGuard = () => {
  useEffect(() => {
    const userId = globals.user_id
    if (!userId) return
    const unsubscribe = subscribeDeviceSession(userId, getDeviceId(), forceStaffLogout)
    return unsubscribe
  }, [])

  return null
}

export default StaffSessionGuard
